<!--
 优化代码，以slot的形式去加载组件，不再支持动态组件
 降低耦合度
-->
<template lang="html">
  <section class="mock-page-router-wrapper" v-if="isPageShow">
    <!-- <transition name="mpr-ani"> -->
    <div :id="id" class="mpr-body" v-if="action">
      <!-- <component :is="routerName" :params="params"></component> -->
      <slot></slot>
    </div>
    <!-- </transition> -->
  </section>
</template>

<script>
import { getRandom } from '@/utils'

export default {
  beforeCreate() {
    const u = location.href
    if (u.indexOf('routerName') > -1) {
      const { path, params, query, name, fullPath } = this.$route
      delete query.routerName
      delete query.routerAction
      delete query._x
      this.$router.replace({
        name,
        path,
        params,
        query: {
          ...query,
          _x: getRandom()
        }
      })
    }
  },
  props: {
    routerName: {
      type: String,
      default: ''
    },
    // params: {
    //   type: Object,
    //   default: () => {},
    // },
    titleFrom: {
      type: String
    },
    titleTo: {
      type: String
    }
  },
  data() {
    return {
      id: 'mockPageRouter_' + getRandom(),
      isPageShow: false,
      scrollTop: 0
    }
  },
  // mounted(){
  //   const u = location.href
  //   if (u.indexOf('routerName') > -1) {
  //     this.show()
  //   }
  // },
  destroyed() {
    this.resetPageScroll()
  },
  watch: {
    isPageShow(val) {
      if (val) {
        this.setPageScrollHidden()
      } else {
        this.resetPageScroll(this.scrollTop)
      }
    }
  },
  computed: {
    action() {
      const action = this.$route.query.routerAction || false
      if (action) {
        this.show()
        this.titleTo && this.$$title(this.titleTo)
      } else {
        this.hide()
        this.titleFrom && this.$$title(this.titleFrom)
      }
      return action
    }
  },
  methods: {
    show() {
      this.isPageShow = true
    },
    hide() {
      this.isPageShow = false
    },
    setPageScrollHidden() {
      this.scrollTop = document.body.scrollTop
      document.body.scrollTop = 0
      document.body.classList.add('of-hide')
      document.documentElement.classList.add('of-hide')
    },
    resetPageScroll(scrollTop = 0) {
      document.body.classList.remove('of-hide')
      document.documentElement.classList.remove('of-hide')
      document.body.scrollTop = scrollTop
    }
  }
  // components: {
  //   storeList: () => import('@/components/storeInfo/storeList'),
  // },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.mock-page-router-wrapper {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
.mpr-body {
  flex: 1;
  background-color: #fff;
}
.mpr-body--toggle {
  transform: translate(0);
  transition: transform 0.3s;
}
// .mpr-ani-enter-active,
// .mpr-ani-leave-active {
//   transform: translate(0);
//   transition: transform 0.6s;
// }
// .mpr-ani-enter,
// .mpr-ani-leave-to {
//   transform: translate(100%, 0);
// }
</style>
